var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPerson = function SvgPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.85 11c.717 0 1.313 0 1.802.038.511.04.982.125 1.435.336a4 4 0 0 1 1.662 1.442c.273.418.424.872.535 1.372.107.48.191 1.069.293 1.78l.413 2.89A1 1 0 0 1 15 20H1a1 1 0 0 1-.99-1.141l.413-2.892c.102-.71.186-1.3.293-1.779.111-.5.262-.954.535-1.372a4 4 0 0 1 1.662-1.442c.453-.21.924-.296 1.435-.336C4.838 11 5.433 11 6.15 11H9.85zM8 9a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9z"
  })));
};
export default SvgPerson;